import declare from "dojo/_base/declare";
import Controller from "csi/action/Controller";
import NewMixin from "csi/table/NewMixin";
import _AggregateProductMixin from "./_AggregateProductMixin";
import { C8Node } from "csi/typings";

const AddToAffectedItemsController = declare([Controller, NewMixin, _AggregateProductMixin], {
	/** @property {C8Node[]} _newlyCreatedAffectedItems -  List of newly created AffectedItems */
	_newlyCreatedAffectedItems: null,

	/** @property {Boolean} bAddToNewGroup -  boolean to allow adding new AffectedItem to new group */
	bAddToNewGroup: true,

	/** @override
	 * Store newly created AffectedItems
	 */
	onPublishResponse(response: any): void {
		if (this._newlyCreatedAffectedItems === null) {
			this._newlyCreatedAffectedItems = response.getNodesOfType("AffectedItem");
		}
		this.inherited(arguments);
	},

	/** @override
	 * Get newly created AffectedItems
	 */
	getNewNodes(): C8Node[] {
		if (this._newlyCreatedAffectedItems == null) {
			return [];
		}
		const newNodes:C8Node[] =  [...this._newlyCreatedAffectedItems];
		this._newlyCreatedAffectedItems = null;

		return newNodes;
	},

	/** @override
	 * Forward processing to Newmixin
	 */
	postProcessSuccess(): void{
		this._newPostProcess();
	},
});

export = AddToAffectedItemsController;